module.exports = __webpack_public_path__ + "img/962275e8bc775d0fa04c2ac779977645.png";